"use client";

import { createContext, useContext } from "react";
import { DEFAULT_LANGUAGE, LANGUAGE_COOKIE_NAME, LANGUAGES } from "@/constants/languages";
import type { LanguageContextType, Language } from "@/types/interfaces/language";

export type { Language };
export { DEFAULT_LANGUAGE, LANGUAGE_COOKIE_NAME };

export const isSupportedLanguage = (value: string): value is Language =>
  LANGUAGES.some((language) => language.value === value);

export const LanguageContext = createContext<LanguageContextType | null>(null);

export function useLanguage(): LanguageContextType {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return ctx;
}
